
const TermsOfUse = () => {
    return <h1>Termos de Uso do Movi</h1>;
};

export default TermsOfUse;